var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.$vuetify.breakpoint.mdAndDown)?_c('period-selector'):_vm._e(),_c('period-survey'),(_vm.$store.get('enrollment/selected@is_content_registration'))?_c('content-dashboard'):_c('tryout-dashboard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }